import { createContext, useContext } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";
import noop from "lodash/noop";

import { useTopics } from "../../hooks/topics/useTopics";
import { BenchmarkGranularity } from "../../types/common";

import { useTopicsDataContext } from "./TopicsDataContext";
import type { TopicsContextSchema } from "./types";

const initialState: TopicsContextSchema = {
    activationId: "",
    granularity: BenchmarkGranularity.WEEKLY,
    country: 0,
    downloadingTopics: [],
    onSort: noop,
    onFilter: noop,
    onDownloadExcel: noop,
    updateTopic: noop,
    deleteTopic: noop,
};

export const TopicsContext = createContext(initialState);

export const TopicsContextProvider = ({ children }) => {
    const {
        params: { key: activationId, country, timeGranularity: granularity },
    } = useCurrentStateAndParams();
    const { setFilter, setSorting } = useTopicsDataContext();

    const { onSort, onFilter, onDownloadExcel, updateTopic, deleteTopic, downloadingTopics } = useTopics({
        setFilter,
        setSorting,
    });

    return (
        <TopicsContext.Provider
            value={{
                activationId,
                granularity,
                country,
                onSort,
                onFilter,
                onDownloadExcel,
                updateTopic,
                deleteTopic,
                downloadingTopics,
            }}
        >
            {children}
        </TopicsContext.Provider>
    );
};

export const useTopicsContext = () => {
    const context = useContext(TopicsContext);

    if (context === undefined) {
        throw new Error("useTopicsContext must be used within a TopicsContextProvider");
    }

    return context;
};
